var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInstagramQuick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A0D1F082-ECB2-4F9E-8415-E4DEF617D8EB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CoreFit-Landing-Page-Option3",
    transform: "translate(-1355.000000, -743.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "banner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quick-right-button",
    transform: "translate(1320.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0116571,11.0002286 L46.3680381,11.0526476 C48.8850799,11.0811399 50.9185935,13.1146534 50.9470857,15.6316952 L51,19 L50.9998095,19.0116571 L50.9472381,22.3680381 C50.9188264,24.8851138 48.8852662,26.918674 46.3681905,26.9470857 L43,27 L42.9883429,26.9997714 L39.6319619,26.9473524 C37.1148478,26.9189431 35.0812207,24.8854175 35.0526857,22.3683048 L35,19 L35.0002286,18.9883429 L35.0526476,15.6318476 C35.0812631,13.1147688 37.1148436,11.0812899 39.6319238,11.0528 L43,11 L43.0116571,11.0002286 Z M43,14.8917714 C41.3383732,14.8917714 39.8403523,15.892684 39.2044645,17.4278226 C38.5685768,18.9629612 38.92005,20.7299898 40.0949922,21.9049428 C41.2699343,23.0798959 43.0369596,23.4313854 44.5721041,22.7955119 C46.1072486,22.1596384 47.1081905,20.6616268 47.1081905,19 C47.1056502,16.7321559 45.267844,14.8943327 43,14.8917714 Z M41.1484331,17.1484981 C41.8972982,16.3996222 43.023538,16.1755928 44.001986,16.580875 C44.9804339,16.9861572 45.6184,17.9409372 45.6184,19 C45.6167245,20.4454149 44.4454148,21.6167586 43,21.6184381 C41.9409372,21.6184381 40.9861479,20.9805013 40.5808515,20.0020593 C40.175555,19.0236172 40.3995681,17.8973741 41.1484331,17.1484981 Z M47.1342095,13.8946666 C46.7597584,13.8945896 46.4221389,14.1201044 46.278807,14.4660374 C46.1354752,14.8119704 46.2146633,15.2101828 46.4794402,15.4749598 C46.7442172,15.7397367 47.1424296,15.8189248 47.4883626,15.675593 C47.8342956,15.5322611 48.0598104,15.1946416 48.0597334,14.8201905 C48.0596282,14.3090814 47.6453186,13.8947718 47.1342095,13.8946666 Z",
    id: "ic_instagram-quick"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagramQuick);
export default __webpack_public_path__ + "static/media/ic_instagram-quick.77db873071a198d2e90a4536c819d35e.svg";
export { ForwardRef as ReactComponent };